




















































import { Component, Vue } from 'vue-property-decorator';
import { I18nService } from '@cds/i18n';
import { Inject } from '@cds/common';
import { GroupService } from '@/services/group-service';
import { DialogService } from '@/services/common/dialog.service';
import { divisionMap } from './index.config';
import { DivisionOrg, TYPESTATU } from './index.interface';
import { CloseStatus } from '@/services/common/models/dialog.interface';
import { UserGroupService } from '@/services/user-group-service';
import { uuid } from '@/services/utils';
import UserGroupDetail from '@/views/userGroup/UserGroupDetail.vue';
import ChannelRuleEdit from '@/views/channel/permissions/dialogs/ChannelRuleEdit.vue';
import ModifyUserGroup from '@/components/UserGroup/ModifyUserGroup.vue';
import UploadUserGroup from '@/views/userGroup/dialog/UploadUserGroup.vue';
import UserGroupTagGroup from '@/components/UserGroup/UserGroupTagGroup.vue';
import {some, cloneDeep } from 'lodash';

@Component({ components: { UserGroupDetail, UserGroupTagGroup } })
export default class Permissions extends Vue {
  public appName: any = '';
  private loading: boolean = false;
  public isPharma: boolean = false;
  public isOnco: boolean = false;
  public isHrCore: boolean = false; // 添加HR Core
  public isNonFf: boolean = false; // 添加Non Ff
  private searchText: string = '';
  private allGroups: any[] = [];
  private userVoList: any[] = [];

  private activeUserGroup: any[] = [];
  @Inject(UserGroupService) private userGroupService!: UserGroupService;
  @Inject(GroupService) private groupService!: GroupService;

  @Inject(DialogService) private dialog!:DialogService;

  @Inject(I18nService) private i18nSvc!: I18nService;
  get i18n(): Dict<any> {
    return this.i18nSvc.i18nData;
  }
  public activeNames: any[] = [];
  public filterNames: any[] = ['1', '2', '3']; // 添加HR core
  public permissionsList: any[] = [];
  public isShow: boolean = true;
  public typeStatus: Dict<any> = TYPESTATU;
  private applicationId: any;
  private ruleOptions: any[] = [];
  private politOptions: any[] = [];
  private hrCoreRuleOptions: any[] = []; // HR Core Rules
  private ruleValue: any[] = [];
  private politValue: any[] = [];
  private hrCoreRuleValue: any[] = []; // 选中的hr core rule
  private totalUsers: any = 0;
  private totalGroups: any = 0;
  private totalList: any[] = [];
  public tagbarSpan: any = 21;


  public async created(): Promise<void> {
    this.appName = this.$route.query.name;
    let controlTypes: any = this.$route.query.types; // 访问权限范围
    let userScopes: any = this.$route.query.userScopes; // 用户范围
    console.log("controlTypes")
    console.log(this.$route.query.types)
    console.log(this.$route.query.userScopes)
    debugger
    if (
      (controlTypes as string[]).some((item: string) => item.toLowerCase() === (localStorage.getItem("setup") || '').toLowerCase()) &&
      userScopes.toLowerCase().includes(TYPESTATU.PHARMA.toLowerCase())
    ) {
      this.isPharma = true;
    }
    // 判断是否含有HR CORE
    if (
      (controlTypes.includes('HR Core Org') && userScopes.includes(TYPESTATU.HRCORE))
    || (controlTypes.includes('P&O Org') && userScopes.includes(TYPESTATU.POORG))
    ) {
      this.isHrCore = true;
    }
    if (
      controlTypes.includes('NON FF') &&
      userScopes.includes(TYPESTATU.NONFF)
    ) {
      this.isNonFf = true;
    }
    this.initAllUserGroups();
  }

  public async modifyUserGroupConfirm(): Promise<void> {
    this.loading = true;
    try {
      await this.getUserGroupsByApplication(this.$route.query.id);
    } finally {
      this.loading = false;
    }
  }

  public async initAllUserGroups(): Promise<void> {
    this.loading = true;
    try {
      await this.getUserGroupsByApplication(this.$route.query.id);
      if (this.allGroups) {
        this.activeUserGroup = [this.allGroups[0]];
        this.activeUserGroup[0].refreshTime = Date.now()
      }else{
        this.activeUserGroup = []
        this.userVoList = []
      }
    } finally {
      this.loading = false;
    }
  }

  public mounted(): void {
    setTimeout(() => {
      const targetBreadcrumb = document.querySelector(
        '#breadcrumb_items_appPermission'
      ) as HTMLElement;
      const targetTitleDom = targetBreadcrumb.querySelector(
        'span.el-breadcrumb__inner.is-link'
      ) as HTMLElement;
      targetTitleDom.innerText = this.$route.query.name + '权限控制';
    });
  }

  private changeActiveUserGroup(val: any) {
    let newVal = cloneDeep(val);
    newVal.refreshTime = Date.now();
    this.activeUserGroup = [newVal];
  }

  private async searchFilteredRules(val: any) {
    this.loading = true;
    if (this.searchText !== '') {
      let res = await this.groupService.searchUserGroupsByApplicationKeyword({
        keyword: this.searchText ? this.searchText : '',
        appId: this.$route.query.id
      })
      this.allGroups = res.userGroupVOList;
      this.activeUserGroup = res.userGroupVOList;
      this.userVoList = res.userVoList;
      //mock
      //this.userVoList = [{
      //   bu: null,
      //   deptCode: "110090942",
      //   deptName: "North AD",
      //   division: "CTS",
      //   email: "647382911@novartis.com",
      //   employeeCode: "",
      //   employeeId: "647382911",
      //   franchise: null,
      //   groupId: null,
      //   post: null,
      //   userId: 21795,
      //   userName: null
      //}];
    }else{
      this.initAllUserGroups();
    }
    this.loading = false;

  }

  private async modifyAppUserGroups(): Promise<void> {
    const key = uuid();
    this.searchText = '';
    await this.getUserGroupsByApplication(this.$route.query.id);
    const res = await this.dialog.open('修改应用权限规则', ChannelRuleEdit, {
      userGroups: this.allGroups,
      applicationId: this.applicationId,
      appName: this.appName,
      hasPharmaPermission: this.isPharma,
      hasOncoPermission: this.isOnco,
      hasHrCorePermission: this.isHrCore,
      hasNonFfPermission: this.isNonFf,
      key
    });

    console.log(res);
    if (res.action === CloseStatus.confirm) {
      this.initAllUserGroups();
      this.searchText = '';
      // 重新调取查询
      // this.getUserGroups(type);
    }
  }

  private clearSearch(val: any) {
    this.initAllUserGroups();
  }

  public onCancel(): void {
    this.$router.go(-1);
  }

  // 已选中的
  private async getUserGroupsByApplication(id: any): Promise<void> {
    this.applicationId = id;
    let res = await this.groupService.getUserGroupsByApplication({
      applicationId: id
    });
    this.totalUsers = res.totalOfUsers === null ? this.totalUsers : res.totalOfUsers;
    this.totalGroups = res.userGroups === null ? this.totalGroups : res.userGroups.length;
    this.allGroups = res.userGroups;
   }

  public async refreshUserGroupList(value:any){
    await this.initAllUserGroups();
  }

}
